
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/augments/[[...slug]]",
      function () {
        return require("private-next-pages/augments/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/augments/[[...slug]]"])
      });
    }
  